import { motion } from "framer-motion";

export default function HomeHero() {
  return (
    <section data-testid="home-hero" className="relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(217,45,32,0.10),transparent_55%)]" aria-hidden="true" />
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12 pt-28 md:pt-32 pb-8 md:pb-10">
        <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.02] text-[#F5F5F0]">
          <span className="block overflow-hidden pb-1">
            <motion.span
              className="block"
              initial={{ y: "115%" }}
              animate={{ y: 0 }}
              transition={{ duration: 1, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
              data-testid="home-hero-title"
            >
              AC INVESTING
            </motion.span>
          </span>
        </h1>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.65, duration: 0.8 }}
          className="font-display italic text-xl md:text-2xl text-[#FF6B00] mt-4"
          data-testid="home-hero-subtitle"
        >
          Comprendre où se déplace la valeur.
        </motion.p>
      </div>
    </section>
  );
}
